import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CryptoJsService } from '../../core/services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {

  private refreshTimeoutId: any;

  constructor(
    private localStorage: CryptoJsService,
    private router: Router
  ) {}

  scheduleFromRefreshToken(refreshTokenParam?: string | null): void {
    // Limpiamos cualquier timer anterior
    console.log('AutoLogoutService - scheduleFromRefreshToken called');
    console.log('refreshTimeoutId before clear:', this.refreshTimeoutId);
    if (this.refreshTimeoutId) {
      clearTimeout(this.refreshTimeoutId);
    }
    console.log('refreshTokenParam', refreshTokenParam);

    let refreshToken = refreshTokenParam;
    if (!refreshToken) {
      refreshToken = this.localStorage.getItem('refresh_token'); // 👈 misma key que en LoginService/Interceptor
    }

    if (!refreshToken) {
      return;
    }

    const exp = this.getTokenExpiration(refreshToken); // en ms

    if (!exp) {
      return;
    }

    const now = Date.now();
    const msUntilExp = exp - now;

    // Opcional: hacemos logout unos segundos antes de que expire del todo
    const bufferMs = 5000; // 5 segundos antes
    const timeoutMs = msUntilExp - bufferMs;

    if (timeoutMs <= 0) {
      // Ya expiró o está por expirar → logout inmediato
      this.doLogout();
      return;
    }

    this.refreshTimeoutId = setTimeout(() => {
      this.doLogout();
    }, timeoutMs);
  }

  /**
   * Decodifica un JWT y devuelve exp en milisegundos
   */
  private getTokenExpiration(token: string): number | null {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000; // exp en segundos → ms
    } catch {
      return null;
    }
  }

  /**
   * Logout básico SIN usar LoginService para evitar ciclo de dependencias.
   */
  private doLogout(): void {
    // Limpieza explícita (por claridad)
    this.localStorage.removeItem('token');
    this.localStorage.removeItem('refresh_token');
    this.localStorage.clear();

    this.router.navigate(['/login']);
  }
}
